export const purchaseTypes = {
  digitalDocumentBasis: "digital_document_basis",
  digitalDocumentReview: "digital_document_review",
  digitalDocumentAdvice: "digital_document_advice",
  digitalDocumentWalkthrough: "digital_document_walkthrough",
  registration: "registration",
  courtFee: "court_fee",
} as const;
